import React from 'react';

import { JiraCodingAgentIcon } from '@atlaskit/logo';

import LogoTable from '../utils/logo-table';

export default (): React.JSX.Element => (
	<LogoTable icon={<JiraCodingAgentIcon appearance="brand" />} />
);
